var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.596,
    height: 14.596,
    viewBox: "0 0 14.596 14.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-icon",
    transform: "translate(-672.817 -589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M371.5,116.143a.715.715,0,1,0,.434.333A.715.715,0,0,0,371.5,116.143Z",
    transform: "translate(310.109 475.434)",
    fill: "#52c8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M283.625,193.741l-.011,0c-.675.243-1.537.775-1.347.063l1.306-4.873c.182-.678-.824-.647-1.451-.389a9.133,9.133,0,0,0-2.017,1.408h0a.267.267,0,0,0,.252.456l.011,0c.675-.243,1.537-.775,1.347-.063l-1.306,4.873c-.182.678.824.647,1.451.389a9.134,9.134,0,0,0,2.017-1.408.267.267,0,0,0-.253-.456Z",
    transform: "translate(398.074 405.268)",
    fill: "#52c8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M105.3,28a7.3,7.3,0,1,0,3.649.978A7.3,7.3,0,0,0,105.3,28Zm0,13.785a6.494,6.494,0,1,1,4.585-1.9,6.487,6.487,0,0,1-4.585,1.9Z",
    transform: "translate(574.816 561.001)",
    fill: "#52c8f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/Infoicon.0e00652a42586ab260deba6b358314d5.svg";
export { ForwardRef as ReactComponent };